export const investorPermissions = [
  {
    label: "Users",
    items: [
      { label: "List", key: "USERS_LIST" },
      { label: "Create User", key: "USERS_CREATE" },
      { label: "Update User", key: "USERS_UPDATE" },
      { label: "Delete User", key: "USERS_DELETE" },
      { label: "Block/Unblock User", key: "USERS_BLOCK" },
    ],
  },
  {
    label: "ICD Investments",
    items: [
      { label: "View Fund Requirements", key: "VIEW_FUND_REQUIREMENTS" },
      {
        label: "Show interest Fund Requirements",
        key: "SHOW_INTEREST_FUND_REQUIREMENTS",
      },
      { label: "Counter Fund Requirements", key: "COUNTER_FUND_REQUIREMENTS" },
      { label: "Create Fund Availability", key: "CREATE_FUND_AVAILABILITY" },
      { key: "HR" },
      { label: "Investments List", key: "INVESTMENTS_LIST" },
      { label: "View Investment", key: "VIEW_INVESTMENT" },
      { label: "Accept Investment Request", key: "ACCEPT_INVESTMENT_REQUEST" },
      { label: "Reject Investment Request", key: "REJECT_INVESTMENT_REQUEST" },
      { key: "HR" },
      { label: "Payment List", key: "ICD_PAYMENTS" },
      { label: "Online Payments", key: "ONLINE_PAYMENT_INVESTMENT" },
      { label: "Offline Payments", key: "OFFLINE_PAYMENT_INVESTMENT" },
      { key: "HR" },
      { label: "Signing Requests List", key: "ICD_SIGNING_REQUESTS" },
      { label: "Sign Schedule", key: "SIGN_ICD_SIGNING_REQUESTS" },
    ],
  },
  {
    label: "Reports",
    items: [
      { label: "TDS Certificates", key: "TDS_CERTIFICATES" },
      { label: "Account Statements", key: "ACCOUNT_STATEMENTS" },
      { label: "Investment Schedules", key: "INVESTMENT_SCHEDULES" },
    ],
  },
  {
    label: "Account",
    items: [
      { label: "Profile Update", key: "PROFILE_UPDATE" },
      { label: "KYC Details", key: "PROFILE_KYC_DETAILS" },
      { label: "Executed Documents", key: "PROFILE_EXECUTED_DOCS" },
    ],
  },
  {
    label: "Resources",
    items: [
      { label: "About ICDs", key: "RESOURCES_ABOUT_ICD" },
      { label: "About Prachay", key: "RESOURCES_ABOUT_PRACHAY" },
      { label: "About FAQs", key: "RESOURCES_FAQ" },
      { label: "Sample Documents", key: "RESOURCES_DOCUMENTS" },
      { label: "Videos", key: "RESOURCES_VIDEOS" },
    ],
  },
  {
    label: "Help",
    items: [{ label: "Help Create", key: "HELP" }],
  },
]
